// Products feature carousel.
//
// Vertical product list + big visual. Navigation is click-only: clicking a
// product name switches the active visual and expands its detail. The page
// scrolls normally through the section — no scroll hijacking / pinning.
//
// Progressive enhancement: without JS the first product stays open and every
// product is reachable as plain content.

function initVCarousel(root) {
  const tabs    = Array.from(root.querySelectorAll('[data-vtab]'));
  const items   = tabs.map((t) => t.closest('.product-vcarousel__item'));
  const visuals = Array.from(root.querySelectorAll('[data-vvisual]'));
  if (tabs.length < 2) return;

  let current = -1;

  function setActive(i) {
    if (i === current) return;
    current = i;
    tabs.forEach((t, idx) => {
      const on = idx === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      items[idx].classList.toggle('is-active', on);
      items[idx].style.setProperty('--seg', on ? '1' : '0');
    });
    visuals.forEach((v, idx) => v.classList.toggle('is-active', idx === i));
  }

  tabs.forEach((t, i) => t.addEventListener('click', () => setActive(i)));

  setActive(0);
}

function initVCarousels() {
  document.querySelectorAll('[data-vcarousel]').forEach(initVCarousel);
}

if (document.readyState !== 'loading') initVCarousels();
else document.addEventListener('DOMContentLoaded', initVCarousels);
